import { useState } from 'react'
import { Lookup } from 'src/common/Common.Type'
import Field from 'src/component/field'
import "../style.css"
const DataRow = ({ setData, data, index, onDelete }: { setData: Function, data: any[], index: number, onDelete: Function }) => {

    const [rowData, setDataRow] = useState({ diseaseName: null, notes: "" })

    const handleChange = (key: string, value: Lookup | null | "") => {
        setDataRow(prev => ({ ...prev, [key]: value }))
        let tempData = data
        tempData[index][key] = value
        setData([...tempData])
    }

    const handleDelete = () => {
        let tempData = data.filter((item, itemIndex) => itemIndex != index)
        onDelete(tempData)
        setDataRow(prev => ({
            diseaseName: tempData[index]?.diseaseName,
            notes: tempData[index]?.notes
        }))
    }

    return (
        <div className='row row-section '>
            <Field className='col-md-6' placeholder='diseaseName' label={'diseaseName'} value={rowData["diseaseName"]} setValue={val => handleChange("diseaseName", val)} />
            <Field className='col-md-6' placeholder='note' label={'note'} value={rowData["notes"]} setValue={val => handleChange("notes", val)} />
            {data?.length != 1 &&
                <div className='delete-icon' onClick={handleDelete}>
                    x
                </div>
            }
        </div>
    )
}

export default DataRow